<template>
  <div class="image-text">
    <slot name="text"></slot>
    <slot name="image"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextTopLeft",
};
</script>

<style lang="scss" scoped>
.image-text {
  flex-direction: column;
}
</style>
